var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeesAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,11.1c1.4,0,2.6-1.2,2.6-2.6S20.3,6,18.9,6s-2.6,1.2-2.6,2.6S17.4,11.1,18.9,11.1z M10.3,11.1 c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4S6.9,5.8,6.9,7.7C6.9,9.6,8.4,11.1,10.3,11.1z M21.4,12c-0.9,0-1.7,0-1.7,0l-0.9,1.7 L18,12c0,0-0.1,0-0.9,0c-0.8,0-0.9,0-0.9,0s1.7,1.4,1.7,4.3V18h6c0,0,0-0.5,0-2.6C24,13.4,22.3,12,21.4,12z M13.7,12 c-0.9,0-1.7,0-1.7,0l-1.7,2.6L8.6,12c0,0-0.5,0-1.7,0s-3.4,1.5-3.4,4.1c0,2,0,3.7,0,3.7h13.7c0,0,0-0.9,0-3.4 C17.1,13.7,14.6,12,13.7,12z M3.4,12v-1.7h1.7V8.6H3.4V6.9H1.7v1.7H0v1.7h1.7V12H3.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesAddIcon);
export default __webpack_public_path__ + "static/media/employees_add_icon.6aa35575.svg";
export { ForwardRef as ReactComponent };